export const mockV1PartnerPut = {
  partnerId: 'b19d5e6b-2074-401b-8b67-e969f132d99a'
};

export default mockV1PartnerPut;
